import styled from '@emotion/styled';

import hex2rgba from 'utils/colors';

export const Movement = styled.div((_) => ({
  display: 'flex',
  gap: 8,
}));

export const Icon = styled.div((_) => ({
  display: 'flex',
  alignItems: 'center',
  padding: 2,
  borderRadius: 5,
  width: 20,
  height: 20,
  svg: {
    witdh: 15,
    height: 15,
  },
}));

export const Primary = styled(Icon)(({ theme }) => ({
  color: theme.colors.transactionTypes.primary,
  background: hex2rgba(theme.colors.transactionTypes.primary, 0.05),
  border: `1px solid ${hex2rgba(theme.colors.transactionTypes.primary, 0.3)}`,
  path: {
    fill: theme.colors.transactionTypes.primary,
  },
}));

export const Secondary = styled(Icon)(({ theme }) => ({
  color: theme.colors.transactionTypes.secondary,
  background: hex2rgba(theme.colors.transactionTypes.secondary, 0.05),
  border: `1px solid ${hex2rgba(theme.colors.transactionTypes.secondary, 0.3)}`,
  path: {
    fill: theme.colors.transactionTypes.secondary,
  },
}));

export const FormattedAsId = styled.span(({ theme }) => ({
  fontFamily: theme.fonts.secondary,
  fontSize: 13,
  color: theme.colors.inactive,
}));

export const AlignRight = styled.div(() => ({
  textAlign: 'right',
}));
